class HHMiniCartGWP extends HTMLElement {
  constructor() {
    super()
    if (!window.gwp?.enabled) { return }

    this.allGWPItemsInCart = null
    this.gwpConfig = this.initializeGWPConfig()
    this.selector = this.gwpConfig.selector

    if (!this.selector) { return }

    this.giftQuantity = this.selector.giftQuantity
    this.currentGiftCount = 0
    this.maxGifts = this.selector.maxGifts

    this.addEventListener('addGWPItem', this.handleAddGWPItem)
    this.addEventListener('removeGWPItem', this.handleRemoveGWPItem)
  }

  connectedCallback() {
    this.dispatchEvent(new CustomEvent('validateCart', { 
      detail: {
        gwpConfig: this.gwpConfig,
        maxGifts: this.maxGifts
      },
      bubbles: true,
      composed: true
    }))

    const updateDOM = (e) => {
      const { totalCartWithoutGWP, allGWPItemsInCart } = e.detail
      this.allGWPItemsInCart = allGWPItemsInCart
      const totalGWPQuantity = this.allGWPItemsInCart.reduce((acc, item) => acc + item.quantity, 0)
      this.currentGiftCount = totalGWPQuantity
      this.updateGiftStatus()
    }

    document.addEventListener('gwpUpdate', updateDOM)
  }

  initializeGWPConfig() {
    let enabled = false
    let selector = null

    for (const gwp of window.gwp.discounts) {
      enabled = true
      selector = gwp
      break
    }

    return { enabled, selector }
  }

  handleAddGWPItem(event) {
    if (this.currentGiftCount >= this.maxGifts) {
      return
    }

    this.handleGWPItemEvent(
      event,
      'addGWPProduct',
      'Failed to add product'
    )
  }

  handleRemoveGWPItem(event) {
    this.handleGWPItemEvent(
      event,
      'removeGWPProduct',
      'Failed to remove product'
    )
  }

  handleGWPItemEvent(event, customEventName, errorMessage) {
    const variantId = event.detail.key
    this.setLoading(true)
  
    return new Promise((resolve, reject) => {
      const handler = (e) => {
        if (e.detail.success) {
          resolve(e.detail)
          customEventName === 'addGWPProduct'
            ? this.currentGiftCount += this.giftQuantity
            : this.currentGiftCount -= this.giftQuantity

          this.updateGiftStatus()
        } else {
          reject(new Error(errorMessage))
        }
      }
  
      document.addEventListener('gwpDone', handler, { once: true })
  
      this.dispatchEvent(new CustomEvent(customEventName, {
        detail: { variantId, giftQuantity: this.giftQuantity },
        bubbles: true,
        composed: true
      }))
    }).finally(() => {
      this.setLoading(false)
    }).catch((error) => {
      console.error(logMessage, customEventName, error)
    })
  }

  updateGiftStatus() {
    if (this.currentGiftCount >= this.maxGifts) {
      this.classList.add('gwp-completed')
    } else {
      this.classList.remove('gwp-completed')
    }
    setTimeout(() => {
      const giftItemsContainer = document.querySelector('[data-gift-items]')

      if (giftItemsContainer) {
        if (this.allGWPItemsInCart.length > 0) {
          giftItemsContainer.classList.remove('hide')
        } else {
          giftItemsContainer.classList.add('hide')
        }
      }
    }, 0)
  }

  setLoading(state = false) {
    this.classList.toggle('is-loading', state)
  }
}

if (!customElements.get('hh-mini-cart-gwp')) {
  customElements.define('hh-mini-cart-gwp', HHMiniCartGWP);
}